import { getCdnBaseUrl } from './cdn-util'

const REMOTE_ASSETS_PATH =
  /http(s)?:\/\/(franklin-assets\.s3\.amazonaws\.com|cash-f\.squarecdn\.com|cash-images-f\.squarecdn\.com)\//

/**
 * Replaces CDN URLs with local proxy URLs for development environments.
 * Similar to replaceWithCDNImageUrl but without image-specific width parameters.
 */
export const replaceWithCDNUrl = (url: string | undefined): string | undefined => {
  if (!url || !url.match(REMOTE_ASSETS_PATH)) {
    return url
  }

  const sourcePath = url.replace(REMOTE_ASSETS_PATH, '')
  return `${getCdnBaseUrl()}/${sourcePath}`
}
